import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgStreamingModule } from '@videogular/ngx-videogular/streaming';

import { PlayerComponent } from './player.component';
import { playerFeatureKey, PlayerReducer } from './state/player.reducer';

@NgModule({
  declarations: [
    PlayerComponent,
  ],
  imports: [
    CommonModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    VgStreamingModule,
    StoreModule.forFeature(playerFeatureKey, PlayerReducer),

    // other app modules used inside player
    // ....Module,
  ],
  // used by other modules
  exports: [
    PlayerComponent,
  ],
  providers: [
  ],
})
export class PlayerModule {
}
